import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useFirebase } from '../contexts/FirebaseContext';
import { Card, CardHeader, CardContent } from './ui/Card';
import { Button } from './ui/Button';
import { LanguageSelector } from './ui/LanguageSelector';
import './IntroCard.css';

interface IntroCardProps {
  onStart: () => void;
}

export function IntroCard({ onStart }: IntroCardProps) {
  const { t } = useLanguage();
  const { flushQueue } = useFirebase();

  // Attempt to flush any queued submissions when returning to intro screen
  useEffect(() => {
    flushQueue();
  }, [flushQueue]);

  return (
    <Card variant="intro">
      <CardHeader>
        <div></div>
        <LanguageSelector />
      </CardHeader>

      <CardContent>
        <div className="text-center">
          <h1 className="intro-title text-bold mb-l">
            {t('title')}
          </h1>
          <h2 className="intro-subtitle mb-m">
            {t('subtitle')}
          </h2>
          <p className="intro-institution mb-xl">
            {t('institution')}
          </p>
        </div>

        <div className="mb-xl">
          <p className="intro-text mb-l">
            {t('instructions')}
          </p>
          <p className="intro-text">
            {t('info')}
          </p>
        </div>

        <div className="center-button">
          <Button onClick={onStart}>
            {t('button')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}